import React from 'react';
import Link from 'next/link'
import moment from "moment";
import {Carousel} from "react-responsive-carousel";

const BlogSingle = ({data,context}) => {

    const {org} =context
    let cover=null

    const item=data

    if(item.type === "IMAGE" && item.images.length===1){
        cover=<img src={item.images[0]}/>
    }

    if(item.type === "IMAGE" && item.images.length>1){
        cover=(
            <Carousel infiniteLoop autoPlay showThumbs={false} statusFormatter={(current,total)=>current+" sur "+total}>
                {item.images.map(i=><img src={i}/>)}
            </Carousel>
        )
    }

    return(
        <section className="wpo-blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-8 col-12">
                        <div className="wpo-wpo-blog-content clearfix">
                            <div className="post">
                                {cover &&(
                                    <div className="entry-media">
                                        {cover}
                                    </div>
                                )}
                                <ul className="entry-meta">
                                    <li><span style={{textTransform:"uppercase",cursor:"pointer"}}> {org.contact.prenom} {org.contact.nom}</span></li>
                                    <li><Link href={"#"}>{moment(item.datetime).format("DD MMM YYYY")}</Link></li>
                                </ul>
                                <h2>{item.title}</h2>
                                <div dangerouslySetInnerHTML={{__html:item.content}}/>
                            </div>

                            {Array.isArray(item.thematiques) && item.thematiques.length>0 &&(
                                <div className="tag-share clearfix">
                                    <div className="tag">
                                        <ul>
                                            {item.thematiques.map(t=>(
                                                <li><a href={"#"}>{t}</a></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}

                        </div>

                    </div>
                    {/*<BlogSidebar/>*/}
                </div>
            </div>
        </section>
     )

}

export default BlogSingle;
